import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ItGcWithoutDesignEffectivenessCount from './ItGcWithoutDesignEffectivenessCount';

function ISA315ItProcessItRiskToolbar({label, entityId, bodyId, openViewModal}) {
	// const engagementId = useEngagementId();
	// const dispatch = useDispatch();

	// const updateUnrelatedItGcCount = () => {
	// 	return dispatch(
	// 		getAllItControls(
	// 			engagementId,
	// 			{
	// 				IsUnrelated: true,
	// 				ITApproachTypeId: itControlApproachType.controls
	// 			},
	// 			{bodyId, metadataKey: 'unrelatedItControls'},
	// 			promiseAreas.ITPROCESS_UNRELATED_ITGC_COUNT
	// 		)
	// 	);
	// };

	// const viewItControls = (itControlIdsSelector) => {
	// 	openViewModal({
	// 		entityId: entities.ItControl,
	// 		allIdsSelector: itControlIdsSelector,
	// 		bodyId: bodyId,
	// 		modalTitle: labels.itProcessItRiskUnrelatedITGCUppercase,
	// 		modalDescription: labels.unrelatedItGCModalMessage,
	// 		onModalHide: updateUnrelatedItGcCount
	// 	});
	// };

	return (
		<StyledISA315ItProcessItRiskToolbar>
			<ItGcWithoutDesignEffectivenessCount
				bodyId={bodyId}
				// onCountClick={viewItControls}
				className="itgc-without-design-effectiveness-container"
			/>
		</StyledISA315ItProcessItRiskToolbar>
	);
}

const StyledISA315ItProcessItRiskToolbar = styled.section`
	display: flex;
	align-items: flex-end;
	width: 100%;
	.itgc-without-design-effectiveness-container {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		margin-right: var(--px-5);
	}
`;

ISA315ItProcessItRiskToolbar.propTypes = {
	buttonLabel: PropTypes.string,
	entityId: PropTypes.number,
	bodyId: PropTypes.number
};

export default ISA315ItProcessItRiskToolbar;
